import React from 'react';
import { Info } from 'lucide-react';

interface UnverifiedPartnerBannerProps {
  partnerUsername: string;
}

export const UnverifiedPartnerBanner: React.FC<UnverifiedPartnerBannerProps> = ({
  partnerUsername
}) => {
  return (
    <div className="bg-amber-900/20 border-b border-amber-500/30 px-4 py-2.5">
      <div className="flex items-center gap-3">
        <div className="flex-shrink-0 w-8 h-8 rounded-full bg-amber-500/20 flex items-center justify-center">
          <Info className="w-4 h-4 text-amber-400" />
        </div>
        <div className="min-w-0">
          <p className="text-sm text-white leading-tight">
            <span className="font-semibold">{partnerUsername}</span> ainda não foi verificado
          </p>
          <p className="text-xs text-white/60 leading-tight">
            Recomendamos cautela ao compartilhar informações pessoais
          </p>
        </div>
      </div>
    </div>
  );
};
